// extracted by mini-css-extract-plugin
module.exports = {"thumbs":"SortableThumbnails_thumbs__3j6aH","thumb":"SortableThumbnails_thumb__3mEYa"};